























import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "ResetPasswordCompleted",
})
export default class ResetPasswordCompleted extends Vue {
  public isShow = false;

  public show() {
    this.isShow = true;
  }

  public redirectTologin() {
    this.$router.push({ name: "login" });
  }
}
